import { ImageIcon } from 'lucide-react';
type ImageSlotProps = {
  /** Photo URL. When omitted, a styled placeholder renders instead. */
  src?: string;
  alt?: string;
  /** Shown inside the placeholder to describe the intended photo. */
  label: string;
  /** Tailwind aspect ratio class, e.g. 'aspect-[4/3]'. */
  aspect?: string;
  /**
   * How the image fills the slot. Use 'contain' for square brand cards and
   * logos so nothing gets cropped; 'cover' for photography.
   */
  fit?: 'cover' | 'contain';
  className?: string;
};

/**
 * Reserves space for photography we haven't shot yet.
 *
 * Once a `src` is supplied it renders the real image; until then it shows a
 * dashed placeholder at the same dimensions, so adding photos later doesn't
 * shift the layout.
 */
export function ImageSlot({
  src,
  alt,
  label,
  aspect = 'aspect-[4/3]',
  fit = 'cover',
  className = ''
}: ImageSlotProps) {
  if (src) {
    return <div className={`${aspect} overflow-hidden bg-[#111] ${className}`} data-id="element-77" data-mp="374zsng982dwz">
        <img src={src} alt={alt ?? ''} className={`w-full h-full ${fit === 'contain' ? 'object-contain' : 'object-cover'}`} loading="lazy" data-id="element-78" data-mp="2vyh9y7n5mopm" />
      </div>;
  }
  return <div role="img" aria-label={`Placeholder for ${label}`} className={`${aspect} border-2 border-dashed border-white/15 bg-[#101010] flex flex-col items-center justify-center text-center px-6 ${className}`} data-id="element-79" data-mp="2mykp6h3vy9zu">
      <ImageIcon className="text-[#D97E3A]/40 mb-3" size={30} strokeWidth={1.5} aria-hidden="true" data-id="element-80" data-mp="3er1k47v2q543" />
      <span className="font-inter text-sm text-white/40" data-id="element-81" data-mp="35w3o2rwmqc8j">{label}</span>
      <span className="font-inter text-xs text-white/25 mt-1" data-id="element-82" data-mp="30xtswhawnbmx">
        Photo coming soon
      </span>
    </div>;
}